import config from '../config/config'

let isEnabled = false;
let _loglevel = 1;

logLevel(config.logLevel);

function error(o) {
    if (_loglevel < 1) return;
    if (typeof(o)==="string") o = "*** " + o;
    console.log(o);
}
function info(o) {
    if (_loglevel < 2) return;
    if (typeof(o)==="string") o = "*** " + o;
    console.log(o);
}
function debug(o) {
    if (_loglevel < 3) return;
    if (typeof(o)==="string") o = "*** " + o;
    console.log(o);
}

function logLevel(s) {
    switch (s.toLowerCase()) {
        case "debug":
            _loglevel = 3;
            break;
        case "info":
            _loglevel = 2;
            break;
        case "error":
        default:
            _loglevel = 1;
            break;
    }
}

let Logger = {
    "error": error,
    "info": info,
    "debug": debug,
    "logLevel": logLevel
}

export default Logger


// WEBPACK FOOTER //
// ./src/util/logger.js